module.exports = __webpack_public_path__ + "img/gohere.b6035bff.svg";